<template>
  <div class="slider-form slider-form--care-home slider-form--facility">
    <transition name="slide-next">
      <div class="slider-form__item" v-if="slideNo === 1" v-cloak>
        <h3 class="slider-form__header slider-form__header--lm mb-4">What level of care does your facility offer?</h3>

        <div class="radio-container radio-container--type radio-container--facility">
          <div class="row" v-for="(option, index) in slide1FirstOptions" :key="index">
            <div class="col-md-6">
              <div
                class="radio-group"
                :class="{ 'radio-group--active': levelOfCare.indexOf(option.value) !== -1 }"
                @click="clickCheckBoxLabel"
              >
                <input
                  type="checkbox"
                  class="checkbox"
                  :id="makeIdValue(option.name)"
                  :value="option.value"
                  v-model="levelOfCare"
                />
                <label :for="makeIdValue(option.name)" :class="{ 'active': levelOfCare.indexOf(option.value) !== -1 }">
                  <i :class="getIconClass(option.icon, option.value, 'levelOfCare')"></i>
                  <span v-html="option.name"></span>
                </label>
              </div>
            </div>
            <div class="col-md-6">
              <input
                type="text"
                class="form-control"
                name="levelOfCareBeds[]"
                v-model="levelOfCareBeds[index]"
                placeholder="Number of beds ..."
                :disabled="!(levelOfCare.indexOf(option.value) !== -1)"
              />
            </div>
          </div>
        </div>
        <h3 class="slider-form__header slider-form__header--lm mb-4 mt-6">Does your care home offer?</h3>
        <div class="radio-container radio-container--type radio-container--facility mb-4">
          <div class="row" v-for="option in slide1SecondOptions" :key="option.value">
            <div class="col-md-6">
              <div
                class="radio-group"
                :class="{ 'radio-group--active': levelOfCare.indexOf(option.value) !== -1 }"
                @click="clickCheckBoxLabel"
              >
                <input
                  type="checkbox"
                  class="checkbox"
                  :id="makeIdValue(option.name)"
                  :value="option.value"
                  v-model="levelOfCare"
                />
                <label :for="makeIdValue(option.name)" :class="{ 'active': levelOfCare.indexOf(option.value) !== -1 }">
                  <i :class="getIconClass(option.icon, option.value, 'levelOfCare')"></i>
                  <span v-html="option.name"></span>
                </label>
              </div>
            </div>
            <div class="col-md-6 d-none d-md-block">
              <input type="text" class="form-control bg-porcelain" disabled />
            </div>
          </div>
        </div>
        <button name="next" class="btn btn--green" :disabled="levelOfCare.length === 0" @click.prevent="nextSlide(2)">Next step</button>
      </div>
    </transition>
    <transition name="slide-next">
      <div class="slider-form__item" v-if="slideNo === 2" v-cloak>
        <h3 class="slider-form__header slider-form__header--lm">What types of rooms do you offer?</h3>

        <div class="radio-container radio-container--type justify-content-start">
          <div
            v-for="option in slide2Options"
            :key="option.name"
            class="radio-group radio-group--type mr-3"
            :class="{ 'radio-group--active': rooms.indexOf(option.value) !== -1 }"
            @click="clickCheckBoxLabel"
          >
            <input
              type="checkbox"
              class="checkbox"
              :id="makeIdValue(option.name)"
              name="rooms"
              :value="option.name"
              v-model="rooms"
            />
            <label :for="makeIdValue(option.name)" :class="{ 'active': rooms.indexOf(option.value) !== -1 }">
              <i :class="getIconClass(option.icon, option.name, 'rooms')"></i>
              <span v-html="option.name" class="font-weight-bold"></span>
            </label>
          </div>
          <div class="fs-14 font-lato font-italic font-weight-bold mb-4">
            <span class="color-lime-green mr-2 font-weight-bold">*</span>Serviced apartments that offer rest home and/or hospital level care.
          </div>
          <button name="next" class="btn btn--green" :disabled="rooms.length === 0" @click.prevent="nextSlide(3)">Next step</button>
        </div>
      </div>
    </transition>
    <transition name="slide-next">
      <div class="slider-form__item" v-if="slideNo === 3" v-cloak>
        <h3 class="slider-form__header slider-form__header--lm">What is the total number of beds?</h3>

        <div class="radio-container radio-container--type">
          <div
            v-for="option in slide3Options"
            :key="option.name"
            class="radio-group radio-group--type radio-group--small"
            :class="{ 'radio-group--active': beds === option.name }"
            @click="submitSlide(4, 'beds', option.name)"
          >
            <input type="radio" :id="makeIdValue(option.name)" name="beds" :value="option.name" v-model="beds" />
            <label :for="makeIdValue(option.name)" :class="{ 'active': beds === option.name }">
              <i :class="getIconClass(option.icon, option.name, 'beds')"></i>
              <span v-html="option.name" class="font-weight-bold"></span>
            </label>
          </div>
        </div>
      </div>
    </transition>
    <transition name="slide-next">
      <div class="slider-form__item" v-if="slideNo === 4" v-cloak>
        <h3 class="slider-form__header slider-form__header--lm">What is the name of your facility?</h3>
        <label for="facility" class="sr-only">facility</label>
        <input
          id="facility"
          v-model="facility"
          type="text"
          placeholder="Your facility name ..."
          class="form-control slider-form__input"
          :class="{ 'is-danger': errors.facility }"
          name="facility"
          autocomplete="off"
        />
        <span v-if="errors.facility" class="is-danger mb-4">{{ errors.facility }}</span>
        <button name="next" class="btn btn--green fs-20" @click.prevent="sendEnquiry">Submit</button>
      </div>
    </transition>
    <transition name="slide-next">
      <div class="slider-form__item" v-if="slideNo === 5" v-cloak>
        <div class="slider-form__success-round"><i class="icon icon--tick"></i></div>
        <h3 class="slider-form__header">Thank you, your responses<br>were submitted successfully.</h3>
      </div>
    </transition>
    <a href="#" @click.prevent="back" v-if="slideNo > 1 && slideNo < 5" class="slider-form__back-link" v-cloak>Back</a>
    <div class="slider-form__progress-light-green" v-if="slideNo > 1 && slideNo < 5">
      <div class="slider-form__progress-green" :style="{ width: percentage + '%' }"></div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'

const slideNo = ref(1)
const percentage = ref(20)
const levelOfCareBeds = ref([])
const facility = ref('')
const inputName = ref('')
const levelOfCare = ref([])
const rooms = ref([])
const beds = ref('')
const errors = ref({})

const dataMap = {
  beds,
  rooms,
  levelOfCare,
}

const slide1FirstOptions = [
  { name: 'Rest home', value: 'Rest home care', icon: 'icon-tick' },
  { name: 'Hospital', value: 'Hospital care', icon: 'icon-tick' },
  { name: 'Dementia', value: 'Dementia care', icon: 'icon-tick' },
  { name: 'Psychogeriatric', value: 'Psychogeriatric care', icon: 'icon-tick' },
]

const slide1SecondOptions = [
  { name: 'Palliative', value: 'Palliative care', icon: 'icon-tick' },
  { name: 'Respite', value: 'Respite care', icon: 'icon-tick' },
  { name: 'Day care', value: 'Day care', icon: 'icon-tick' },
]

const slide2Options = [
  { name: 'Standard', icon: 'icon-tick' },
  { name: 'Premium', icon: 'icon-tick' },
  { name: 'Care suites', icon: 'icon-tick' },
  { name: 'Serviced apartments *', icon: 'icon-tick' },
  { name: 'Other', icon: 'icon-tick' },
]

const slide3Options = [
  { name: '50 or less', icon: '' },
  { name: '51 to 75', icon: '' },
  { name: '76 to 100', icon: '' },
  { name: '101 to 125', icon: '' },
  { name: '126 to 150', icon: '' },
  { name: 'More than 150', icon: '' },
]

const nextSlide = async (nextSlideNo) => {
  slideNo.value = nextSlideNo
  calculatePercentage()
}

const getIconClass = (icon, value, inputModalName) => {
  const dataVal = dataMap[inputModalName]
  const iconActive = (dataVal.value.indexOf(value) !== -1) ? `${icon}--active` : ''
  return `${icon} ${iconActive}`
}

const isCheckboxChecked = (value, inputModalName) => {
  console.log(inputModalName, inputModalName.value)
  return inputModalName.indexOf(value) !== -1
}

const makeIdValue = (value) => {
  return value.toLowerCase().replace(/ /g, "_")
}

const submitSlide = (nextSlideNo, inputModalName, value = '') => {
  const dataVal = dataMap[inputModalName]
  slideNo.value = nextSlideNo
  if (value !== '') {
    dataVal.value = value
  }
  calculatePercentage()
}

const clickCheckBoxLabel = (e) => {
  if (e.target.getElementsByClassName('checkbox')[0] !== undefined) {
    e.target.getElementsByClassName('checkbox')[0].click()
  }
}

const sendEnquiry = async () => {
  if (facility.value !== '') {
    errors.value = {}
    slideNo.value = 5
    calculatePercentage()

    axios.post('/learn-more-suggest-enquiry-submit', {
      levelOfCare: levelOfCare.value,
      levelOfCareBeds: levelOfCareBeds.value,
      rooms: rooms.value,
      facility: facility.value,
      beds: beds.value,
      name: inputName.value,
      _token: document.head.querySelector("[name~=csrf-token][content]").content,
    }).then(function (response) {})
  } else {
    errors.value.facility = 'Facility name is required'
  }
}

const back = () => {
  slideNo.value = slideNo.value - 1
  calculatePercentage()
}

const calculatePercentage = () => {
  percentage.value = (slideNo.value * 20)
}
</script>
